import CustomButton from "components/Atoms/CustomButton"
import { VehicleManagementVehicleDetailsQuery } from "generated/graphql"
import React from "react"
import { useNavigate } from "react-router-dom"
import InfoRow from "../InfoRow"
// import { InfoRow } from "../VehicleDetails";
interface VehicleProps {
  vehicleDetails?: VehicleManagementVehicleDetailsQuery["vehicleDetails"]
}
const Vehicle = ({ vehicleDetails }: VehicleProps) => {
  const navigate = useNavigate()
  const type = vehicleDetails?.vehicleType
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-9">
        <InfoRow
          title="Registration Number"
          subtitle={vehicleDetails?.registrationNumber}
        />
        <InfoRow
          title="Vehicle Type"
          subtitle={`${type?.name} ${type?.category}`}
        />
        <InfoRow title="Model Name" subtitle={vehicleDetails?.modelName} />
        <InfoRow title="Purchase Date" subtitle={vehicleDetails?.dateBought} />
        <InfoRow
          title="Chassis Number"
          subtitle={vehicleDetails?.chassisNumber}
        />
        <InfoRow
          title="Fuel Capacity"
          subtitle={vehicleDetails?.fuelTankCapacity?.toString() ?? "0"}
        />
        <InfoRow
          title="Capacity"
          subtitle={`${type?.capacity} ${type?.capacityUnit?.name}`}
        />
        <InfoRow
          title="Estimated Average"
          subtitle={vehicleDetails?.estimatedAverage?.toString()}
        />
      </div>
      <div className="col-span-3">
        <CustomButton
          icon="edit"
          text="Edit Details"
          onClick={e => {
            navigate(`/d/registration/vehicle/${vehicleDetails?.id}`)
          }}
        />
      </div>
    </div>
  )
}

export default Vehicle
